module.exports = __webpack_public_path__ + "img/1.ca02ade4.png";